// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0;
}

.settings-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 2px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.settings-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: white;
}

.back-button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.error-message {
  margin: 16px 24px;
  padding: 12px;
  background: #ffebee;
  color: #d32f2f;
  border-radius: 6px;
  border: 1px solid #ffcdd2;
}

.account-management-content {
  padding: 24px;
}

.account-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.account-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
}

.account-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.account-id {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.account-current-name {
  font-size: 0.85rem;
  color: #666;
}

.account-input-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

.account-input {
  flex: 1 1;
  padding: 10px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.9rem;
  font-family: inherit;
}

.account-input:focus {
  outline: none;
  border-color: #667eea;
}

.btn-save,
.btn-save-all {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-save {
  background: #667eea;
  color: white;
}

.btn-save:hover:not(:disabled) {
  background: #5568d3;
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-save-all {
  background: #667eea;
  color: white;
  width: 100%;
  padding: 12px 20px;
}

.btn-save-all:hover:not(:disabled) {
  background: #5568d3;
}

.btn-save-all:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.account-actions {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 2px solid #e0e0e0;
}

.loading,
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.settings-section {
  margin-top: 32px;
  padding-top: 32px;
  border-top: 2px solid #e0e0e0;
}

.settings-section-title {
  margin: 0 0 20px 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}

.settings-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
}

.settings-label {
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
}

.settings-input-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

.settings-input {
  flex: 1 1;
  padding: 10px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.9rem;
  font-family: inherit;
}

.settings-input:focus {
  outline: none;
  border-color: #667eea;
}

.settings-current-value {
  font-size: 0.85rem;
  color: #666;
  font-style: italic;
}

/* Tabs */
.settings-tabs {
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  background: #f5f5f5;
  padding: 0 24px;
  gap: 0;
}

.settings-tab {
  padding: 14px 24px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  color: #666;
  transition: all 0.2s ease;
  position: relative;
  margin-bottom: -2px;
}

.settings-tab:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.05);
}

.settings-tab.active {
  color: #667eea;
  border-bottom-color: #667eea;
  background: white;
  font-weight: 600;
}

.settings-tab-content {
  padding: 24px;
  min-height: 300px;
}

/* Compact account items */
.account-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.account-item {
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
}

.account-actions {
  display: none; /* Remove Save All button */
}

/* Grants styling */
.grants-section {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
}

.grants-section-title {
  margin: 0 0 16px 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.grants-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.grant-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.grant-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.grant-username {
  font-weight: 600;
  color: #333;
  min-width: 120px;
}

.grant-date {
  font-size: 0.85rem;
  color: #666;
}

.grant-status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

.grant-status.active {
  background: #e8f5e9;
  color: #2e7d32;
}

.grant-status.inactive {
  background: #ffebee;
  color: #c62828;
}

.btn-revoke {
  padding: 6px 16px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-revoke:hover:not(:disabled) {
  background: #d32f2f;
}

.btn-revoke:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.settings-section-description {
  margin: 0 0 20px 0;
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
}

.radio-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.95rem;
}

.radio-label input[type="radio"] {
  cursor: pointer;
  width: 18px;
  height: 18px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.settings-checkbox {
  margin: 0;
  cursor: pointer;
}

.settings-help-text {
  font-size: 0.85rem;
  color: #666;
  margin-top: 4px;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/AccountDisplayNameManagement.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,2BAA2B;AAC5C;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".settings-page {\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 0;\n}\n\n.settings-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 2px solid #e0e0e0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.settings-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: white;\n}\n\n.back-button {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.back-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.error-message {\n  margin: 16px 24px;\n  padding: 12px;\n  background: #ffebee;\n  color: #d32f2f;\n  border-radius: 6px;\n  border: 1px solid #ffcdd2;\n}\n\n.account-management-content {\n  padding: 24px;\n}\n\n.account-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.account-item {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.account-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.account-id {\n  font-weight: 600;\n  color: #333;\n  font-size: 1rem;\n}\n\n.account-current-name {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.account-input-group {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.account-input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-family: inherit;\n}\n\n.account-input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.btn-save,\n.btn-save-all {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.btn-save {\n  background: #667eea;\n  color: white;\n}\n\n.btn-save:hover:not(:disabled) {\n  background: #5568d3;\n}\n\n.btn-save:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-save-all {\n  background: #667eea;\n  color: white;\n  width: 100%;\n  padding: 12px 20px;\n}\n\n.btn-save-all:hover:not(:disabled) {\n  background: #5568d3;\n}\n\n.btn-save-all:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.account-actions {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 2px solid #e0e0e0;\n}\n\n.loading,\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n}\n\n.settings-section {\n  margin-top: 32px;\n  padding-top: 32px;\n  border-top: 2px solid #e0e0e0;\n}\n\n.settings-section-title {\n  margin: 0 0 20px 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.settings-item {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.settings-label {\n  font-weight: 500;\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.settings-input-group {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.settings-input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-family: inherit;\n}\n\n.settings-input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.settings-current-value {\n  font-size: 0.85rem;\n  color: #666;\n  font-style: italic;\n}\n\n/* Tabs */\n.settings-tabs {\n  display: flex;\n  border-bottom: 2px solid #e0e0e0;\n  background: #f5f5f5;\n  padding: 0 24px;\n  gap: 0;\n}\n\n.settings-tab {\n  padding: 14px 24px;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #666;\n  transition: all 0.2s ease;\n  position: relative;\n  margin-bottom: -2px;\n}\n\n.settings-tab:hover {\n  color: #667eea;\n  background: rgba(102, 126, 234, 0.05);\n}\n\n.settings-tab.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n  background: white;\n  font-weight: 600;\n}\n\n.settings-tab-content {\n  padding: 24px;\n  min-height: 300px;\n}\n\n/* Compact account items */\n.account-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n}\n\n.account-item {\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.account-actions {\n  display: none; /* Remove Save All button */\n}\n\n/* Grants styling */\n.grants-section {\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.grants-section-title {\n  margin: 0 0 16px 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.grants-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.grant-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f9f9f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n.grant-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.grant-username {\n  font-weight: 600;\n  color: #333;\n  min-width: 120px;\n}\n\n.grant-date {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.grant-status {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.grant-status.active {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.grant-status.inactive {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.btn-revoke {\n  padding: 6px 16px;\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-revoke:hover:not(:disabled) {\n  background: #d32f2f;\n}\n\n.btn-revoke:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.settings-section-description {\n  margin: 0 0 20px 0;\n  color: #666;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.radio-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n}\n\n.radio-label input[type=\"radio\"] {\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.settings-checkbox {\n  margin: 0;\n  cursor: pointer;\n}\n\n.settings-help-text {\n  font-size: 0.85rem;\n  color: #666;\n  margin-top: 4px;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
